import styled from 'styled-components';

const FixedWithContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 1920px;
  min-width: 1000px;
  flex-direction: column;
  justify-content: start;
  position: relative;
  background-color: blue;
  overflow: auto;
  padding-bottom: 32px;
  background-color: transparent;
`;

export default FixedWithContainer;
